module.exports = __webpack_public_path__ + "static/media/react-native.0d5548f9.png";